/**
 * Optional Sentry. Set VITE_SENTRY_DSN in .env.mobile / .env.production.
 * No-ops when DSN is missing so local builds stay quiet.
 */
export async function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return false;
  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE || 'production',
      tracesSampleRate: 0.08,
      ignoreErrors: [
        'ResizeObserver loop',
        'Non-Error promise rejection',
        'Load failed',
        'NetworkError',
      ],
    });
    return true;
  } catch (err) {
    console.warn('Sentry init skipped', err?.message || err);
    return false;
  }
}
